<template>
  <div
    data-test="uploads-loading-error"
    class="request-details__uploads-loading-error-container"
  >
    <i
      aria-hidden="true"
      class="fa-regular fa-exclamation-circle text-danger"
    />
    <div>
      <slot />
    </div>
  </div>
</template>
